
import React, { useState } from 'react';
import { Button, Card, Modal } from 'react-bootstrap';
import ReactGA from 'react-ga';
const ImageCard = (props: any) => {
    const [zoomShow, setZoomShow] = useState(false);
    const item = props.item;
    const image = item.image;
    const url = image.thumbnail;
    return <><Card>
        <Card.Img variant="top" className="m-auto p-2 cursor-zoom-in" src={url} onClick={() => setZoomShow(true)} />
        <Card.Body>
            {item.label && <Card.Title>{item.label}</Card.Title>}
            {item.description && <Card.Text>{item.description}</Card.Text>}
            <Card.Text><Button variant="outline-secondary" size="sm" onClick={() => {
                ReactGA.event({
                    category: "Image",
                    action: "download",
                    label: "Image Download",
                    dimension1: image.original
                });
                window.location.href = image.original;
            }}>Download</Button></Card.Text>
        </Card.Body>
    </Card>
        <Modal
            dialogClassName="modal-90w"
            show={zoomShow}
            onHide={() => setZoomShow(false)}
            aria-labelledby={`zoom-image-${image.id}`}
        >
            <Modal.Header closeButton>
                {item.label}
            </Modal.Header>
            <Modal.Body><img src={image.zoom} className="w-100" alt={item.description} /></Modal.Body>
        </Modal>
    </>
}
export default ImageCard;
